import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { isNotNil } from '@web/utils';
import { DD_MM_YYYY_HH_MM_SS_SSS } from '@web/common';
import {
  DateFormatPipe,
  getColumnKey,
  NoDataComponent,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import { AdminBoxQuantityHistoryReasonTypeComponent } from '../admin-box-quantity-history-reason-type/admin-box-quantity-history-reason-type.component';
import { AdminBoxQuantityHistoryCollectionFilter } from '../../models/admin-box-quantity-history-collection-filter';
import { AdminBoxQuantityHistoryCollectionItem } from '../../models/admin-box-quantity-history-collection-item';

@Component({
  selector: 'app-admin-box-quantity-history-list-custom-cell-template',
  imports: [
    DateFormatPipe,
    NoDataComponent,
    TableBodyNoReferenceCellComponent,
    AdminBoxQuantityHistoryReasonTypeComponent,
  ],
  templateUrl:
    './admin-box-quantity-history-list-custom-cell-template.component.html',
  styleUrl:
    './admin-box-quantity-history-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminBoxQuantityHistoryListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<AdminBoxQuantityHistoryCollectionItem, AdminBoxQuantityHistoryCollectionFilter>>();
  /* prettier-ignore */
  public readonly model = input.required<AdminBoxQuantityHistoryCollectionItem>();
  /* prettier-ignore */
  protected readonly getColumnKey = getColumnKey<AdminBoxQuantityHistoryCollectionItem>;
  protected readonly isNotNil = isNotNil;
  protected readonly DD_MM_YYYY_HH_MM_SS_SSS = DD_MM_YYYY_HH_MM_SS_SSS;
}
